<template>
  <div class="fantan-game">
    <div class="fantan-game-result">
      <!-- <div class="total-result">{{ $t("fantan.total") }} : {{ totalResult }}</div> -->
      <div class="fantan-top-label">
  
        <div
          class="fantan-result-label"
          :class="drawResult.fan"
        >{{$t("fantan.fan") }}{{ drawResult.fan}}</div>
        <!-- <div class="fantan-result-label" :class="resultOe">{{$t("fantan." +resultOe) }}</div> -->
        <div v-if="this.gameData.prev.oe == 1"
        class="fantan-result-label" :class="resultOe">{{ $t("fantan.odd") }}</div>
        <div v-else
        class="fantan-result-label" :class="resultOe">{{ $t("fantan.even") }}</div>

      </div>
      <div ref="bowl-img" class="bowl-img-container">
        <img style="width: 100%" src="../../assets/images/fantan/bowl.png" />
      </div>
      <div class="fantan-trend">
        <Row type="flex" justify="space-between">
          <Col
            ref="fantan-trend-lot-col"
            class="fantan-trend-lot-col"
            v-for="n in 18"
            :key="n"
          >
            <Row v-for="m in 4" :key="m">
              <div
                ref="'fantan-trend-lot-cell'+(((n-1)*4) + m)"
                class="fantan-trend-lot-cell"
                v-if="(n - 1) * 4 + m <= totalResult"
              ></div>
              <div
                v-else
                :ref="'fantan-trend-lot-cell-neg' + ((n - 1) * 4 + m)"
                class="fantan-trend-lot-cell-neg"
              ></div>
            </Row>
          </Col>
        </Row>
      </div>
    </div>

    <fantan-game-category
      :game="game"
      :game-data="gameData"
      :minutes-string="minutesString"
      :seconds-string="secondsString"
      :showDrawingAnimation="showDrawingAnimation"
      :draw-result="drawResult"
      :count-down="countDown"
      :disallow-betting="disallowBetting"
    />
    <div
      ref="fantan-disallow-betting-section"
      class="fantan-disallow-betting-section"
      v-if="displayDisallowSection"
    >
      <Row
        class="fantan-disallow-betting"
        type="flex"
        justify="center"
        align="middle"
      >
        <Col>
          <div>{{ $t("general.no_more_bet") }}</div>
        </Col>
      </Row>
    </div>
    <div ref="fantan-animation-section" class="fantan-animation-section">
      <div ref="fantan-animation" class="fantan-animation">
        <div ref="fantan-result" class="fantan-result">
          <div ref="fantan-result-cont" class="fantan-result-cont"></div>
        </div>
        <div class="result-container" ref="result-container">
          <div ref="fan-result" class="fan-result" :class="drawResult.fan">
            {{ $t("fantan.fan") }}{{ drawResult.fan }}
          </div>
            <div v-if="this.drawResult.oe  == 1"
        ref="odd-result" class="odd-result">{{ $t("fantan.odd") }}</div>
        <div v-else
        ref="odd-result" class="odd-result">{{ $t("fantan.even") }}</div>
          <!-- <div ref="odd-result" class="odd-result">{{ resultOe }}</div> -->
        </div>
        <div class="result-details" ref="result-details">
          <div class="ssh">
            <div>{{ $t("fantan.ssh") }}</div>
            <div>
              {{ $t("fantan.ssh")}}{{ sshArray[0] }}
              <hr class="solid" />
            </div>
            <div>
              {{ $t("fantan.ssh")}}{{ sshArray[1] }}
              <hr class="solid" />
            </div>
            <div>{{ $t("fantan.ssh")}}{{ sshArray[2] }}</div>
          </div>
          <div class="kwok">
            <div>{{ $t("fantan.kwok") }}</div>
            <div>
              {{ $t("fantan.kwok") }}{{ kwokArray[0] }}
              <hr class="solid" />
            </div>
            <div>{{ $t("fantan.kwok") }}{{ kwokArray[1] }}</div>
          </div>
          <div class="nim">
            <div>{{ $t("fantan.nim") }}</div>
            <div>
              {{ nimArray[0] }}
              <hr class="solid" />
            </div>
            <div>
              {{ nimArray[1] }}
              <hr class="solid" />
            </div>
            <div>{{ nimArray[2] }}</div>
          </div>
          <div class="nga">
            <div>{{ $t("fantan.nga") }}</div>
            <div>
              <div style="display: inline-block; margin-right: 4px">
                {{ ngaArray[0] }}
                <hr class="solid" />
              </div>
              <div style="display: inline-block">
                {{ ngaArray[1] }}
                <hr class="solid" />
              </div>
            </div>

            <div>
              <div style="display: inline-block; margin-right: 4px">
                {{ ngaArray[2] }}
                <hr class="solid" />
              </div>
              <div style="display: inline-block">
                {{ ngaArray[3] }}
                <hr class="solid" />
              </div>
            </div>

            <div>
              <div style="display: inline-block; margin-right: 4px">
                {{ ngaArray[4] }}
              </div>
              <div style="display: inline-block">{{ ngaArray[5] }}</div>
            </div>
          </div>
        </div>

        <div ref="fantan-bowl-box" class="fantan-bowl-box">
          <img
            src="../../assets/images/fantan/bowl.png"
            ref="fantan-bowl"
            class="fantan-bowl"
          />
          <img
            src="../../assets/images/fantan/hand-grab.png"
            ref="fantan-hand"
            class="fantan-hand"
          />
        </div>
        <div ref="fantan-beam-box" class="fantan-beam-box">
          <div
            v-for="(game, index) in fantanBeam"
            ref="fantan-beam"
            class="fantan-beam"
            :key="index"
          ></div>
        </div>
        <div ref="fantan-fake-beam-box" class="fantan-fake-beam-box">
          <div
            v-for="(item, index) in 100"
            :key="index"
            ref="fantan-fake-beam"
            class="fantan-fake-beam"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { snakeCase } from "change-case";
import { random, forEach } from "lodash";
import { TweenLite, TweenMax, TimelineLite } from "gsap";
import { Row, Button, Timeline, Col } from "iview";
import FantanMainBet from "./fantan-game/FantanMainBet";
import FantanGameCategory from "./fantan-game/FantanGameCategory";
import FantanGameResult from "./fantan-game/FantanGameResult";
import EventBus from "../../configs/event-bus";

export default {
  props: [
    "game",
    "gameData",
    "countDown",
    "drawResult",
    "showDrawingAnimation",
    "disallowBetting",
    "displayDisallowSection",
    "minutesString",
    "secondsString",
    "onAnimationEnd",
  ],
  components: {
    FantanMainBet,
    FantanGameCategory,
    FantanGameResult,
    Row,
    Button,
  },
  computed: {
    fantanBeam() {
      if (this.drawResult.draw_result) {
        return parseInt(this.drawResult.draw_result);
      } else {
        return parseInt(this.gameData.prev.draw_result);
      }
    },
    snakeCaseTitle() {
      return snakeCase(this.game);
    },
  },
  data() {
    return {
      totalResult: 0,
      totalResultCounter: 0,
      randomNum: 0,
      isAnimationRunning: false,
      stopAnimation: false,
      displayStopAnimationSection: false,
      resultOe: null,
      sshArray: [],
      kwokArray: [],
      nimArray: [
        "1NIM2",
        "1NIM3",
        "1NIM4",
        "2NIM1",
        "2NIM3",
        "2NIM4",
        "3NIM1",
        "3NIM2",
        "3NIM4",
        "4NIM1",
        "4NIM2",
        "4NIM3",
      ],
      ngaArray: [
        "12NGA3",
        "12NGA4",
        "13NGA2",
        "13NGA4",
        "14NGA2",
        "14NGA3",
        "23NGA1",
        "23NGA4",
        "24NGA1",
        "24NGA3",
        "34NGA1",
        "34NGA2",
      ],
    };
  },
  watch: {
    secondsString() {
      if (this.minutesString == "00" && this.secondsString == "06") {
        TweenLite.to(this.$refs["bowl-img"], 1, {
          y: -50,
        });
      }
    },
    showDrawingAnimation(newVal, oldVal) {
      if (newVal) {
        this.isAnimationRunning = true;
      }
    },
    drawResult(newVal, oldVal) {
      let fantanBowlAnimation = new TimelineLite();
      let fantanBeamAnimation = new TimelineLite();
      let fantanFakeBeamAnimation = new TimelineLite();
      let fantanHandAnimation = new TimelineLite();

      let vm = this;
      this.totalResult = 0;
      this.totalResultCounter = 0;
      let templeft;
      let temptop;

      let winArray = [];
      Object.entries(newVal).forEach((entry) => {
        const [key, value] = entry;
        if (value == 1) winArray.push(key);
      });
      // if (this.drawResult.oe == 1) {
      // this.resultOe = this.$t("fantan.odd");
      // } else {
      // this.resultOe = this.$t("fantan.even");
      // }

      this.sshArray = [];
      if (this.drawResult.ssh123 == 1) {
        this.sshArray.push("123");
      }
      if (this.drawResult.ssh234 == 1) {
        this.sshArray.push("234");
      }
      if (this.drawResult.ssh241 == 1) {
        this.sshArray.push("241");
      }
      if (this.drawResult.ssh341 == 1) {
        this.sshArray.push("341");
      }

      this.kwokArray = [];
      if (this.drawResult.kwok12 == 1) {
        this.kwokArray.push("12");
      }
      if (this.drawResult.kwok14 == 1) {
        this.kwokArray.push("14");
      }
      if (this.drawResult.kwok23 == 1) {
        this.kwokArray.push("23");
      }
      if (this.drawResult.kwok34 == 1) {
        this.kwokArray.push("34");
      }

      this.nimArray = [];
      if (this.drawResult.v1NIM2 == 1) {
        this.nimArray.push("1Nim2");
      }
      if (this.drawResult.v1NIM3 == 1) {
        this.nimArray.push("1Nim3");
      }

      if (this.drawResult.v1NIM4 == 1) {
        this.nimArray.push("1Nim4");
      }
      if (this.drawResult.v2NIM1 == 1) {
        this.nimArray.push("2Nim1");
      }
      if (this.drawResult.v2NIM3 == 1) {
        this.nimArray.push("2Nim3");
      }
      if (this.drawResult.v2NIM4 == 1) {
        this.nimArray.push("2Nim4");
      }
      if (this.drawResult.v3NIM1 == 1) {
        this.nimArray.push("3Nim1");
      }
      if (this.drawResult.v3NIM2 == 1) {
        this.nimArray.push("3Nim2");
      }
      if (this.drawResult.v3NIM4 == 1) {
        this.nimArray.push("3Nim4");
      }
      if (this.drawResult.v4NIM1 == 1) {
        this.nimArray.push("4Nim1");
      }
      if (this.drawResult.v4NIM2 == 1) {
        this.nimArray.push("4Nim2");
      }
      if (this.drawResult.v4NIM3 == 1) {
        this.nimArray.push("4Nim3");
      }

      this.ngaArray = [];
      if (this.drawResult.v12NGA3 == 1) {
        this.ngaArray.push("12Nga3");
      }
      if (this.drawResult.v12NGA4 == 1) {
        this.ngaArray.push("12Nga4");
      }
      if (this.drawResult.v13NGA2 == 1) {
        this.ngaArray.push("13Nga2");
      }
      if (this.drawResult.v13NGA4 == 1) {
        this.ngaArray.push("13Nga4");
      }
      if (this.drawResult.v14NGA2 == 1) {
        this.ngaArray.push("14Nga2");
      }
      if (this.drawResult.v14NGA3 == 1) {
        this.ngaArray.push("14Nga3");
      }
      if (this.drawResult.v23NGA1 == 1) {
        this.ngaArray.push("23Nga1");
      }
      if (this.drawResult.v23NGA4 == 1) {
        this.ngaArray.push("23Nga4");
      }
      if (this.drawResult.v24NGA1 == 1) {
        this.ngaArray.push("24Nga1");
      }
      if (this.drawResult.v24NGA3 == 1) {
        this.ngaArray.push("24Nga3");
      }
      if (this.drawResult.v34NGA1 == 1) {
        this.ngaArray.push("34Nga1");
      }
      if (this.drawResult.v34NGA2 == 1) {
        this.ngaArray.push("34Nga2");
      }

      setTimeout(function () {
        templeft = vm.$refs["fantan-beam-box"].offsetLeft;
        temptop = vm.$refs["fantan-beam-box"].offsetTop;
      }, 50);

      let beamObj = [];
      let fakeBeamObj = [];
      let beamMoveObj = [];

      setTimeout(() => {
        this.totalResult = this.drawResult.draw_result;
      }, 500);
      if (newVal && this.isAnimationRunning) {
        TweenLite.set(vm.$refs["fantan-animation-section"], {
          opacity: 1,
          display: "block",
        });
        setTimeout(() => {
          TweenLite.set(vm.$refs["fantan-animation"], {
            opacity: 1,
          });

          let middlePosition = 50;
          let handmiddlePosition = 53;

          //Fake Beam random position
          vm.$refs["fantan-fake-beam"].forEach((el, i) => {
            fakeBeamObj.push(el);

            TweenLite.set(fakeBeamObj[i], {
              top: `${vm.generateNumber()}%`,
              left: `${vm.generateNumber()}%`,
            });
          });

          //Real Beam random position
          vm.$refs["fantan-beam"].forEach((el, i) => {
            beamObj.push(el);

            TweenLite.set(beamObj[i], {
              top: `${vm.generateNumber()}%`,
              left: `${vm.generateNumber()}%`,
            });
          });

          fantanHandAnimation
            .from(vm.$refs["fantan-hand"], 0.5, {
              top: "120%",
              left: `${handmiddlePosition}%`,
              scale: 1.1,
            })
            .to(vm.$refs["fantan-hand"], 0.2, {
              top: "85%",
              left: `${handmiddlePosition}%`,
              scale: 1.1,
            })
            .to(vm.$refs["fantan-hand"], 0.4, {
              top: "85%",
              left: `${handmiddlePosition}%`,
              scale: 1,
            })
            .to(vm.$refs["fantan-hand"], 0.4, {
              top: "75%",
              left: `${handmiddlePosition}%`,
              scale: 1.1,
            })
            .to(vm.$refs["fantan-hand"], 1, {
              top: "30%",
              left: `${handmiddlePosition}%`,
              scale: 1.1,
            })
            .to(vm.$refs["fantan-hand"], 0.5, {
              top: "30%",
              left: `${handmiddlePosition}%`,
              scale: 1,
            })
            .to(vm.$refs["fantan-hand"], 0.5, {
              top: "45%",
              left: `${handmiddlePosition}%`,
              scale: 1,
            })
            .to(vm.$refs["fantan-hand"], 0.2, {
              top: "45%",
              left: `${handmiddlePosition}%`,
              scale: 1.1,
            })
            .to(vm.$refs["fantan-hand"], 1.5, {
              top: "85%",
              left: `${handmiddlePosition}%`,
              scale: 1.1,
            })
            .to(vm.$refs["fantan-hand"], 0.2, {
              top: "85%",
              left: `${handmiddlePosition}%`,
              scale: 1,
            })
            .to(vm.$refs["fantan-hand"], 0.2, {
              top: "85%",
              left: `${handmiddlePosition}%`,
              scale: 1.1,
            })
            .to(vm.$refs["fantan-hand"], 0.2, {
              top: "120%",
              left: `${handmiddlePosition}%`,
              scale: 1.1,
            });

          // //Bowl moving from top & shaking
          fantanBowlAnimation
            .from(vm.$refs["fantan-bowl"], 0.4, {
              top: "85%",
              left: `${middlePosition}%`,
            })
            .to(vm.$refs["fantan-bowl"], 0.4, {
              top: "75%",
              left: `${middlePosition}%`,
              scale: 1.2,
            })
            //  .to(vm.$refs["fantan-bowl"], 0.4, { top: "75%", left: middlePosition ,scale:1.2 })
            .to(vm.$refs["fantan-bowl"], 1, {
              top: "30%",
              left: `${middlePosition}%`,
              scale: 1.2,
            })
            .to(vm.$refs["fantan-bowl"], 0.5, {
              top: "30%",
              left: `${middlePosition}%`,
              scale: 1,
            })
            .to(vm.$refs["fantan-bowl"], 0.5, {
              top: "45%",
              left: `${middlePosition}%`,
              scale: 1,
            })
            .to(vm.$refs["fantan-bowl"], 0.2, {
              top: "45%",
              left: `${middlePosition}%`,
              scale: 1.2,
            })
            .to(vm.$refs["fantan-bowl"], 1.5, {
              top: "85%",
              left: `${middlePosition}%`,
              scale: 1.2,
            })
            .to(vm.$refs["fantan-bowl"], 0.2, {
              top: "85%",
              left: `${middlePosition}%`,
              scale: 1,
            })
            .delay(0.7);

          // Real beam shaking
          fantanBeamAnimation
            .to(vm.$refs["fantan-beam-box"], 0.5, {
              // left: `${middlePosition}%`,
              top: "50%",
            })
            .delay(3);

          //Remove fake beam box
          fantanFakeBeamAnimation
            .to(vm.$refs["fantan-fake-beam-box"], 0.5, {
              opacity: 0,
              display: "none",
            })
            .delay(2.5);

          //Moving beam to top from 4 by 4

          var last4Beam = beamObj.length % 4;
          var totalbeam = beamObj.length - 1;
          let position;

          if (last4Beam == 0) last4Beam = 4;

          if (last4Beam == 1) {
            position = 56;
            // position = totalResultLeft - templeft + totalResultWidth / 2;
          } else if (last4Beam == 2) {
            position = 46;
            // position = totalResultLeft - templeft + totalResultWidth / 4;
          } else if (last4Beam == 3) {
            position = 36;
            // position = totalResultLeft - templeft + totalResultWidth / 6;
          } else {
            position = 23;
            // position = totalResultLeft - templeft - 5;
          }
          beamObj.forEach((el, i) => {
            let beamMoveAnimation = new TimelineLite();
            // beamMoveObj.push(beamMoveAnimation);
            if (i > totalbeam - last4Beam) {
              beamMoveObj.push(beamMoveAnimation);
              for (
                let beamindex = 0;
                beamindex < beamObj.length - last4Beam;
                beamindex++
              ) {
                TweenLite.to(beamObj[beamindex], 0.5, {
                  opacity: 0,
                }).delay(Math.ceil((i + 1) / 4) * 0.3 + 5.5);
              }
              beamMoveAnimation
                .to(beamObj[i], 0.3, {
                  top: "-148px",

                  left: `${position + (totalbeam - i) * 20}%`,
                  x: "-50%",
                  scale: 1.15,
                  opacity: 1,
                  onComplete: function () {
                    TweenLite.to(vm.$refs["fantan-beam-box"], 0, {
                      opacity: 1,
                      onComplete: function () {
                        TweenLite.to(vm.$refs["result-container"], 1, {
                          display: "block",
                          onComplete: function () {
                            TweenLite.to(vm.$refs["fan-result"], 1, {
                              opacity: 1,
                              x: -60,
                            });
                            TweenLite.to(vm.$refs["result-details"], 1, {
                              display: "block",
                              y: 25,
                            });
                            TweenLite.to(vm.$refs["odd-result"], 1, {
                              opacity: 1,
                              x: 60,
                              onComplete: function () {
                                //Reset animation
                                let stopAnimation = new TimelineLite();
                                stopAnimation
                                  .to(
                                    vm.$refs["fantan-animation-section"],
                                    0.6,
                                    {
                                      opacity: 0,
                                      display: "none",
                                      onComplete: function () {
                                        TweenLite.to(vm.$refs["bowl-img"], 1, {
                                          y: 0,
                                        });
                                        vm.isAnimationRunning = false;
                                        vm.animationEnd();
                                        TweenLite.set(vm.$refs["fantan-bowl"], {
                                          clearProps: "all",
                                        });
                                        TweenLite.set(
                                          vm.$refs["fantan-beam-box"],
                                          {
                                            clearProps: "all",
                                          }
                                        );
                                        TweenLite.set(
                                          vm.$refs["fantan-fake-beam-box"],
                                          {
                                            clearProps: "all",
                                          }
                                        );
                                        TweenLite.set(
                                          vm.$refs["fantan-animation-section"],
                                          {
                                            clearProps: "all",
                                          }
                                        );
                                        TweenLite.set(
                                          vm.$refs["result-container"],
                                          {
                                            clearProps: "all",
                                          }
                                        );
                                        TweenLite.set(
                                          vm.$refs["result-details"],
                                          {
                                            clearProps: "all",
                                          }
                                        );
                                        TweenLite.set(beamObj, {
                                          clearProps: "all",
                                        });
                                        TweenLite.set(vm.$refs["fan-result"], {
                                          clearProps: "all",
                                        });
                                        TweenLite.set(vm.$refs["odd-result"], {
                                          clearProps: "all",
                                        });
                                      },
                                    }
                                  )
                                  .delay(4);
                              },
                            });
                          },
                        });
                      },
                    });
                  },
                })
                .delay(Math.ceil((i + 1) / 4) * 0.3 + 6.5);
            } else {
              // let beamMoveAnimation = new TimelineLite();
              beamMoveObj.push(beamMoveAnimation);
              beamMoveAnimation
                .to(beamObj[i], 0.3, {
                  top: `${
                    vm.$refs["fantan-trend-lot-cell-neg" + (i + 1)][0]
                      .parentElement.offsetTop -
                    temptop -
                    40
                  }px`,
                  // left: `${
                  //   (vm.$refs["fantan-trend-lot-cell-neg" + (i + 1)][0]
                  //     .parentElement.offsetLeft -
                  //     templeft) *
                  //     1.3 +
                  //   35
                  // }px`,
                  left: `${
                    vm.$refs["fantan-trend-lot-cell-neg" + (i + 1)][0]
                      .parentElement.offsetLeft -
                    templeft +
                    107
                  }px`,
                  opacity: 1,
                })
                .delay(Math.ceil((i + 1) / 4) * 0.3 + 5.5);

              //Counting total result
              beamMoveObj[i].eventCallback("onComplete", () => {
                this.totalResultCounter++;
              });
            }
          });

          beamMoveObj[beamMoveObj.length - 1].eventCallback(
            "onComplete",
            () => {
              //Counting the last of the result total result
              this.totalResultCounter = totalbeam + 1;

              clearStakeRecord(this.gameData.gID);
              EventBus.$emit("update-session-storage");
            }
          );
        }, 100);
      }
    },
  },
  mounted() {
    this.totalResult = this.gameData.prev.draw_result;
    EventBus.$emit("update-session-storage");
  },
  methods: {
    generateNumber: function () {
      this.randomNum = Math.floor(Math.random() * (88 - 1) + 1);
      return this.randomNum;
    },

    animationEnd() {
      this.$emit("on-animation-end");
    },
  },
};
</script>

<style lang="scss" scoped>
hr {
  color: #5a5b5d;
  background-color: #5a5b5d;
  height: 1px;
  border: 0;
}

.fantan-game {
  position: relative;
  background: #474b4c;
}

.fantan-top-label {
  display: flex;
  width: 50%;
  background: rgb(0, 0, 0, 0.43);
  justify-content: space-evenly;
  margin-bottom: 5px;
  border: 1px solid #707070;
  border-radius: 0 0 8px 8px;
}

.bowl-img-container {
  position: absolute;
  max-width: 70px;
  /* width: 50px; */
  /* height: 50px; */
  right: 96px;
  top: -42px;
}

.fantan-result-label {
  padding: 3px 0;
  font-size: 13px;
  color: #f27728;
  // font-weight: bold;
}

.fantan-player-banker {
  display: flex;
  padding-bottom: 5px;
  background: #e5eaf8;
}

.fantan-main-bet {
  display: flex;
  height: 178px;
  background-color: black;
}

.fantan-no-bet {
  background-color: black;
}

.fantan-disallow-betting-section {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: white;
  background: rgba(#000000, 0.9);
  font-size: 16px;
}

.result-details {
  text-align: center;
  display: none;
}

.result-details > div {
  display: inline-block;
  font-size: 13px;
  border-radius: 10px;
  text-align: center;
  font-family: "Oswald", sans-serif;
  font-weight: 400;
  min-width: 60px;
  margin: 0 5px;
  vertical-align: top;
  background: rgba(59, 60, 63, 0.5);
}

.result-details > div > div {
  padding: 4px;
  font-size: 14px;
  color: #d0d0d0;
  font-weight: 400;
  font-family: "Oswald", sans-serif;
}

.result-details > div > div:first-child {
  border-radius: 10px 10px 0 0;
  background: linear-gradient(
    rgba(71, 75, 76, 0.7),
    rgba(71, 75, 76, 0.7),
    rgba(44, 46, 48, 0.7),
    rgba(17, 17, 19, 0.7)
  );
}

.nga > div {
  flex: 50%;
}

.fantan-stop-animation-section {
  position: absolute;
  display: none;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: white;
  background: rgba(#000000, 0.9);
  font-size: 16px;
}

.result-container {
  width: 80%;
  height: 52px;
  border: 3px solid #dadada2e;
  background: #000000;
  margin: 0 auto;
  border-radius: 26px;
  display: none;
  text-align: center;
}

.fantan-stop-animation-section.show {
  display: block;
}

.fantan-disallow-betting,
.fantan-stop-animation {
  width: 100%;
  height: 100%;
}

.fantan-animation-container {
  height: 100%;
  width: 100%;
  background: rgba(#000000, 0.9);
}

.fantan-animation-result {
  display: none;
  width: 100%;
  height: 100%;
}

.fantan-animation-result .fantan-animation-result-plate {
  width: 100%;
  height: auto;
  z-index: 99;
}

.fantan-animation-result-container,
.fantan-animation-banner-container {
  position: relative;
}

.fantan-animation-result-container {
  z-index: 2;
}

.fantan-animation-banner-container {
  display: none;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding: 0 20px;
  z-index: 1;
}

.fantan-animation-result-dice {
  display: none;
  width: 15%;
  position: absolute;
  top: 0;
  z-index: 100;
  border-radius: 6px;
  box-shadow: 0 0 4px 2px #00000044;
}

.fantan-animation-result-banner-top,
.fantan-animation-result-banner-sum {
  width: 85%;
  position: absolute;
  top: 25%;
}

.fantan-animation-result-banner-sum {
  top: 27%;
}

.fantan-animation-result-banner-sum-total {
  font-size: 24px;
  color: $tai-xiu-theme-color-6;
  font-weight: bold;
  font-size: 36px;
  line-height: 1;
}

.fantan-animation-result-banner-sum-title {
  color: white;
  font-weight: bold;
}

.fantan-animation-result-banner-bottom,
.fantan-animation-result-banner-game {
  width: 85%;
  position: absolute;
  bottom: 25%;
}

.fantan-animation-result-banner-game {
  bottom: 30%;
}

.fantan-animation-result-banner-game-result {
  padding: 5px;
  background-color: white;
  color: $tai-xiu-theme-color-3;
  font-weight: bold;
  width: 60px;
  margin: 0 5px;
  border-radius: 8px;
  text-align: center;
}

.fantan-game-animation-next-draw {
  background-color: $tai-xiu-theme-color-13;
  color: $tai-xiu-theme-color-5;
  border-radius: 6px;
  font-size: 14px;
  margin-right: 5px;
  padding: 4px 20px;
  font-weight: bolder;
  z-index: 1;
}

.fantan-game-animation-next-draw-section {
  position: absolute;
  top: 20px;
  width: 100%;
}

.fantan-animation-inner {
  position: relative;
  width: 100%;
}

.fantan-animation-banner-inner {
  height: 100%;
}
.fantan-game-result {
  background-image: url(../../assets/images/fantan/bg.png);
  background-size: 100% 100%;
  height: 120px;
  padding: 5px 10px 5px;
  height: 94px;
  width: 100%;
  padding: 0 80px 5px 10px;
  position: relative;
  overflow: hidden;
}

.total-result {
  font-family: "Oswald";
  font-weight: 700;
  text-transform: uppercase;
  width: 100%;

  text-align: left;
  color: #f9cb62;
  font-size: 30px;
  line-height: 30px;
  font-size: 24px;
  line-height: 24px;
}

.fantan-trend-lot-cell {
  background: grey;
  border-radius: 100px;
  width: 10px;
  height: 10px;
  border-radius: 100px;
  margin-top: 4px;
  border-color: 2px solid black;
  animation: pop 0.1s linear 1;
  animation-fill-mode: forwards;
}

.fantan-trend-lot-cell-neg {
  background: grey;
  border-radius: 100px;
  width: 10px;
  height: 10px;
  margin-top: 4px;
}
.fantan-disallow-betting-section {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: white;
  background: rgba(#000000, 0.9);
  font-size: 16px;
  z-index: 11;
}
.fantan-animation-section {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: white;
  // background: rgba(#000000, 0.9);
  background: radial-gradient(
    at top,
    rgb(56, 56, 56, 0.97),
    rgb(0, 0, 0, 0.97)
  );
  font-size: 16px;
  z-index: 10;
  justify-content: center;
  align-items: center;
  opacity: 0;
  display: none;
}
.fantan-animation {
  z-index: 11;
  justify-content: center;
  align-items: center;
  opacity: 0;
}
.fantan-result {
  padding: 10px 0;
  text-align: center;
  font-weight: bold;
  color: #f27728;
  font-size: 20px;
  font-family: "Oswald", sans-serif;
  font-weight: bolder;
  display: flex;
  justify-content: center;
}

.fantan-beam-box {
  position: absolute;
  // border: 1px solid white;
  top: 35%;
  left: 50%;
  transform: translateX(-50%);
  height: 25%;
  width: 120px;
  z-index: 12;

  // border: 2px solid red;
}
.fantan-fake-beam-box {
  top: 35%;
  // border: 1px solid white;
  width: 73%;
  left: 50%;
  transform: translateX(-50%);
  position: absolute;
  height: 25%;
}
.fantan-beam {
  position: absolute;
  // border: 1px solid white;
  // background: white;
  background: transparent linear-gradient(163deg, #ffffff 0%, #9a9a9a 100%);
  box-shadow: 0px 1px 0px #00000029;
  border-radius: 50%;
  height: 13px;
  width: 13px;
  opacity: 1;
}
.fantan-fake-beam {
  height: 13px;
  width: 13px;
  // background-color: white;
  background: transparent linear-gradient(163deg, #ffffff 0%, #9a9a9a 100%);
  box-shadow: 0px 1px 0px #00000029;
  position: absolute;
  // border: 1px solid white;
  border-radius: 50%;
  opacity: 1;
}
.fantan-bowl {
  width: 177px;
  height: 170px;
  top: 85%;
  // left: 25%;
  left: 50%;
  transform: translateX(-50%);
  position: absolute;
  z-index: 13;
}
.fantan-hand {
  width: 200px;
  height: 100%;
  top: 140%;
  // left: 25%;
  left: 60%;
  transform: translateX(-50%);
  position: absolute;
  z-index: 14;
}
.fan-result {
  display: inline-block;
  text-align: center;
  font-size: 25px;
  line-height: 40px;
  font-weight: bold;
  opacity: 0;
  font-family: "Oswald", sans-serif;
  font-weight: bolder;
  // display: none;
}

.fantan-result-label.\31,
.fan-result.\31 {
  color: #c9c9c9;
}
.fantan-result-label.\32,
.fan-result.\32 {
  color: #16cc86;
}
.fantan-result-label.\33,
.fan-result.\33 {
  color: #f9cb62;
}
.fantan-result-label.\34,
.fan-result.\34 {
  color: #fa4358;
}

.odd-result {
  display: inline-block;
  text-align: center;
  font-size: 25px;
  line-height: 40px;
  font-weight: bold;
  color: #f27728;
  opacity: 0;
  font-family: "Oswald", sans-serif;
  font-weight: bolder;
}
@keyframes pop {
  0% {
    transform: scale(1.4);
  }
  100% {
    // background: white;
    background: transparent linear-gradient(163deg, #ffffff 0%, #9a9a9a 100%);
    box-shadow: 0px 1px 0px #00000029;
  }
}
@media only screen and (max-width: 360px) {
  .fantan-animation-result-banner-sum {
    top: 26%;
  }

  .fantan-animation-result-banner-game {
    bottom: 29%;
  }
}
</style>
